import { Header, HeaderLeft } from '../../_components/ui/header'

export const SimulationHeader = () => {
  return (
    <Header className="mx-auto max-w-6xl flex-col gap-1 px-14 pb-10 pt-10">
      <HeaderLeft className="gap-1">
        <div className="flex h-10 items-center">
          <h1 className="text-2xl font-bold text-brand-grayscale-12">Simulação</h1>
        </div>
        <p className="text-sm font-semibold text-brand-grayscale-7">
          Faça uma simulação agora mesmo
        </p>
      </HeaderLeft>
    </Header>
  )
}
